import { Notyf } from 'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

const Methods = {
    
    watch:{

        async 'form_data.building_id'(val)
        {
            if(val)
            {
                let http_request = {
                    id:             val,
                    type_request:   'building',
                }
                const response = await this.get(`${this.lite_rest_api}/${JSON.stringify(http_request)}`)

                this.loader(true)
                
                if(response.status)
                {
                    if(response.data.length)
                    {
                        this.array_options['level_id'] = response.data
                        this.form_data.level_id = ''
                        this.array_options['area_id'] = []
                        this.form_data.area_id = ''
                        notyf.success('Levels available for the selected building')
                    }
                    else
                    {
                        this.array_options['level_id'] = []
                        this.form_data.level_id = ''
                        this.array_options['area_id'] = []
                        this.form_data.area_id = ''
                        notyf.error('No levels available for the selected building')
                    }

                    this.loader()
                }
                else
                {
                    this.error_handling(response)
                    this.loader()
                }
            } else
            {
                this.array_options['level_id'] = []
                this.form_data.level_id = ''
            }
        },

        async 'form_data.level_id'(val)
        {
            if(val)
            {
                let http_request = {
                    id:             val,
                    type_request:   'level',
                }
                const response = await this.get(`${this.lite_rest_api}/${JSON.stringify(http_request)}`)

                this.loader(true)
                if(response.status)
                {
                    
                    if(response.data.length)
                    {
                        this.array_options['area_id'] = response.data
                        this.form_data.area_id = ''
                        notyf.success('Areas available for the selected level')
                    }
                    else
                    {
                        this.array_options['area_id'] = []
                        this.form_data.area_id = ''
                        notyf.error('No areas available for the selected level')
                    }
                    this.loader()
                }
                else
                {
                    this.error_handling(response)
                    this.loader()
                }
            }
            else
            {
                this.array_options['area_id'] = []
                this.form_data.area_id = ''
            }
        },

        display_rooms(val)
        {
            if(val)
            {
                val.forEach(item => item.checked = false)

                this.rooms.forEach(item => item.checked = false)

                this.select_all = false;
            }
        },

    },

    methods: {

        scheduled_form_modal()
        {
            window.$('#static-schedule-rooms').modal('show')
        },

        selectAllBoxes()
        {
            if(this.rooms.length)
            {
                this.display_rooms.map((item) => {
                    item.checked = this.select_all
                })
            }
        },

        async form_submit()
        {

            let room_data = {
                area_id:            this.form_data.area_id,
                room_type_id:       this.form_data.room_type_id,
                floor_id:           this.form_data.floor_id,
                cost_center_id:     this.form_data.cost_center_id,
                closed:             this.form_data.closed,
                exclude_daily:      this.form_data.exclude_daily,
                exclude_project:    this.form_data.exclude_project,
                work_group:         this.form_data.work_group,
                patient:            this.form_data.patient,
            }

            let task_data = {
                task_id:        this.form_data.task_id,
                policing:       this.form_data.policing,
                project:        this.form_data.project,
                freq_simbol:    this.form_data.freq_simbol,
                frequency:      this.form_data.frequency,
            }

            let room_task_data = {
                shift1:     this.form_data.shift1,
                shift2:     this.form_data.shift2,
                shift3:     this.form_data.shift3,
            }

            let form_data = {
                room:       room_data,
                task:       task_data,
                room_task:  room_task_data,
            }

            this.invoke_loader('post')

            const response = await this.post(this.lite_rest_api, form_data)
            
            if(response.status)
            {
                if(response.data.length)
                {
                    this.rooms = response.data
                    notyf.success(`Rooms available!`)
                }
                else
                {
                    notyf.error(`No rooms available!`)
                }
                this.revoke_loader('post')
            } 
            else
            {
                
                this.error_handling(response)
                this.revoke_loader('post')
            }

        },

        async add_duties()
        {
            let advanced_search = this.$refs.advanced_search.returnedRoomsToParent()

            if(!advanced_search.checked_items.length)
            {
                notyf.error('No rooms selected')
                return false
            }

            advanced_search.unchecked_items = advanced_search.unchecked_items.map(item => item.room_task_id)

            this.loader(true)

            const response = await this.patch(this.rest_api, advanced_search)

            this.loader()
            
            if(response.data.status)
            {
                this.notyfMesg('Room tasks were added')
                this.$refs.advanced_search.applySearch()
            } 
            else
            {
                this.validate_data = response.data.data
                window.$('#validations').modal('show')
            }
            this.loader()
        },

        form_modal()
        {
            if(!this.user.has_facility){
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        fill_data(data)
        {
            this.parent                 = data.project
            
            this.rooms_assigned_minutes = data.project.total_minutes

            this.parent_id        = data.parent_id

            this.array_options = {
                building_id:    data.buildings,
                level_id:       '',
                area_id:        '',
                task_id:        data.tasks,
                room_type_id:   data.room_types,
                floor_id:       data.floors,
                cost_center_id: data.cost_centers,
                frequency_id:   data.frequencies,
                group_id:       data.groups
            }

            this.breadcrumb.push(
                {
                    name:   `${this.parent.name}`,
                    href:   `/assignment-project/${this.project_id}`,
                    arrow:  "<span class='slash'>/</span>",
                },
                {
                    name:   `Projects - ${this.parent.name}`,
                    href:   `/assignment-projects-rooms/${this.project_id}`,
                    arrow:  "",
                }
            )
        },

        async calculateMinutes()
        {
            let http_obj = this.$refs.advanced_search.returnedRoomsToParent()

            http_obj['project_id'] = this.parent.id

            http_obj.unchecked_items = http_obj.unchecked_items.map(item => item.room_task_id)

            const response = await this.post(`${this.lite_rest_api}/calculate_minutes`, http_obj)

            if(response.status)
            {
                this.rooms_assigned_minutes = response.data.current_minutes
                this.proposed_minutes       = response.data.proposed_minutes
                this.total_new_minutes      = response.data.total_new_minutes
            }
            else
            {
                this.error_handling(response)
            }
        },

        reloaded()
        {
            window.location.reload()
        },

    },

}

export default Methods